import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import MiniChart from '@/assets/img/MiniChart.png'
import MiniChartUp from '@/assets/img/MiniChartUp.png'
import { Wallet } from '@/core/services/Wallets/WalletInterface'
import { cn } from '@bem-react/classname'

import { trimTrailingZeros } from '@/utils/trimTrailingZeros'

import Icon from '../Icon'
import './Cryptocurrency.scss'

interface ICryptocurrencyProps {
  className?: string
  wallet: Wallet
  up?: boolean
  isHome?: boolean
  currency?: 'USD' | 'EUR'
}

const cnCryptocurrency = cn('Cryptocurrency')

export const Cryptocurrency: FC<ICryptocurrencyProps> = ({
  className,
  wallet,
  up = false,
  isHome = false,
  currency,
}) => {
  // const { width } = useElementSize()
  const navigate = useNavigate()

  const onClick = () => {
    navigate(`/c/wallets/${wallet.code}`)
  }

  const cls = isHome ? [className, 'home'] : [className]

  return (
    <>
      <div
        className={cnCryptocurrency({ home: isHome }, cls)}
        onClick={onClick}
      >
        <div className={cnCryptocurrency('left')}>
          <div
            className={cnCryptocurrency(
              'icon',
              `icon-${wallet.symbol.toUpperCase()} ${wallet.symbol.toUpperCase()}-color-bg`,
            )}
          ></div>
          <div className={cnCryptocurrency('wrap')}>
            <div className={cnCryptocurrency('code')}>
              {wallet.code.toUpperCase()}
            </div>
            <div className={cnCryptocurrency('name')}>{wallet.name}</div>
          </div>
        </div>
        <div className={cnCryptocurrency('center')}>
          <div className={cnCryptocurrency('info')}>
            {!isHome && (
              <div className={cnCryptocurrency('value')}>
                {currency && (currency === 'USD' ? '$' : '€')}{' '}
                {wallet.balance_available}{' '}
                {!currency && wallet.code.toUpperCase()}
              </div>
            )}

            <div className={cnCryptocurrency('small', { up })}>
              {up ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='6'
                  height='15'
                  viewBox='0 0 6 15'
                  fill='none'
                >
                  <path
                    d='M0.6 8.7L2.6 6.03333C2.8 5.76667 3.2 5.76667 3.4 6.03333L5.4 8.7C5.64721 9.02962 5.41202 9.5 5 9.5H1C0.587977 9.5 0.352786 9.02962 0.6 8.7Z'
                    fill='#30DAAD'
                  />
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='6'
                  height='15'
                  viewBox='0 0 6 15'
                  fill='none'
                >
                  <g clipPath='url(#clip0_2059_814)'>
                    <path
                      d='M5.4 6.3L3.4 8.96667C3.2 9.23333 2.8 9.23333 2.6 8.96667L0.6 6.3C0.352787 5.97038 0.587978 5.5 1 5.5L5 5.5C5.41202 5.5 5.64721 5.97038 5.4 6.3Z'
                      fill='#FF6A38'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_2059_814'>
                      <rect
                        width='6'
                        height='14'
                        fill='white'
                        transform='translate(0 0.5)'
                      />
                    </clipPath>
                  </defs>
                </svg>
              )}

              <span>{trimTrailingZeros(wallet.course)}</span>

              {wallet.change && (
                <>
                  {' · '}
                  <span>{wallet.change}</span>
                </>
              )}
            </div>
          </div>

          <div className={cnCryptocurrency('graph')}>
            {up ? (
              <img src={MiniChartUp} alt='MiniChartUp' />
            ) : (
              <img src={MiniChart} alt='MiniChart' />
            )}
          </div>
        </div>
        <div className={cnCryptocurrency('actions')}>
          {!isHome && (
            <>
              <button
                type='button'
                className={cnCryptocurrency('action')}
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  navigate(`/c/wallets/${wallet.code}/receive`)
                }}
              >
                <Icon name='receive' />
                Receive
              </button>
              <button
                className={cnCryptocurrency('action')}
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  navigate(`/c/wallets/${wallet.code}/send`)
                }}
              >
                <Icon name='send' />
                Send
              </button>
            </>
          )}

          {/* <button
            className={cnCryptocurrency('action', {
              buy: true,
              fluid: !!width && width <= 480 && isHome,
            })}
          >
            <Icon name='buy' />
            Buy
          </button> */}
        </div>
      </div>
      {wallet.parents && (
        <>
          {wallet.parents.map((parent, i) => (
            <Cryptocurrency
              className={className}
              isHome={isHome}
              key={i}
              wallet={parent.wallet}
            />
          ))}
        </>
      )}
    </>
  )
}
